export default "__VITE_PUBLIC_ASSET__e330f3d2__"